import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import POList from "@/pages/POList";
import POCreate from "@/pages/POCreate";
import POBulkMap from "@/pages/POBulkMap";
import PODetail from "@/pages/PODetail";
import Vendors from "@/pages/Vendors";
import Outward from "@/pages/Outward";
import OutwardCreate from "@/pages/OutwardCreate";
import OutwardDetail from "@/pages/OutwardDetail";
import AdminReview from "@/pages/AdminReview";
import Stock from "@/pages/Stock";
import ApprovalSummary from "@/pages/ApprovalSummary";
import Transfers from "@/pages/Transfers";
import TransferCreate from "@/pages/TransferCreate";
import Activity from "@/pages/Activity";
import InvoiceManagement from "@/pages/InvoiceManagement";
import BOQManagement from "@/pages/BOQManagement";
import BOQItemDetail from "@/pages/BOQItemDetail";
import BOQBulkLink from "@/pages/BOQBulkLink";
import BudgetRevisions from "@/pages/BudgetRevisions";
import AdminRateRevisions from "@/pages/AdminRateRevisions";

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ProjectProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />

                {/* Material POs */}
                <Route path="pos" element={<POList poType="material" />} />
                <Route path="pos/bulk-map" element={<POBulkMap />} />
                <Route path="pos/new" element={<POCreate poType="material" />} />
                <Route path="pos/:id/edit" element={<POCreate poType="material" />} />
                <Route path="pos/:id" element={<PODetail />} />

                {/* Contract POs */}
                <Route path="contracts" element={<POList poType="contract" />} />
                <Route path="contracts/new" element={<POCreate poType="contract" />} />
                <Route path="contracts/:id/edit" element={<POCreate poType="contract" />} />
                <Route path="contracts/:id" element={<PODetail />} />

                {/* Outward Material */}
                <Route path="outward" element={<Outward />} />
                <Route path="outward/new" element={<OutwardCreate />} />
                <Route path="outward/:id" element={<OutwardDetail />} />

                {/* Transfers */}
                <Route path="transfers" element={<Transfers />} />
                <Route path="transfers/new" element={<TransferCreate />} />

                {/* Approval Summary */}
                <Route path="approval-summary" element={<ApprovalSummary />} />

                {/* Invoice reconciliation */}
                <Route path="invoices" element={<InvoiceManagement />} />
                <Route path="boq" element={<BOQManagement />} />
                <Route path="boq/item/:itemId" element={<BOQItemDetail />} />
                <Route path="admin/boq-bulk-link" element={<BOQBulkLink />} />

                <Route path="vendors" element={<Vendors />} />
                <Route path="stock" element={<Stock />} />
                <Route path="admin/review" element={<AdminReview />} />
                <Route path="admin/activity" element={<Activity />} />
                <Route path="admin/budget-revisions" element={<BudgetRevisions />} />
                <Route path="admin/rate-revisions" element={<AdminRateRevisions />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ProjectProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
